<template>
  <!-- start 输入面板 -->
  <div>
    <template v-if="isPaging == false">
      <div class="input-panel" v-for="(items, key) in value" :key="key">
        <div class="show-input-panel">
          <span
            v-for="(item, key) in items"
            :key="key"
            :class="
              item.inputVal != item.key && item.inputVal != null
                ? 'mistake'
                : ''
            "
          >
            <template>{{ item.key }}</template>
          </span>
        </div>
        <div class="input-panel-input">
          <input
            class="input-class"
            contenteditable="true"
            v-model="inputVals[key]"
            ref="key"
            @keyup="keyboardChangeSeats($event)"
            @keydown="notMobile"
            :disabled="!obtainCursor"
          />
        </div>
      </div>
    </template>
    <div v-if="isPaging == true && isLoading">
      <div v-for="(items, key) in value" :key="key">
        <div class="input-panel" v-if="verifyPage(key + 1)">
          <div class="show-input-panel">
            <span
              v-for="(item, key) in items"
              :key="key"
              :class="
                item.inputVal != item.key && item.inputVal != null
                  ? 'mistake'
                  : ''
              "
            >
              <template>{{ item.key }}</template>
            </span>
          </div>
          <div class="input-panel-input">
            <input
              class="input-class"
              :ref="inputRefName(key)"
              contenteditable="true"
              v-model="inputVals[key]"
              :maxlength="items.length"
              @keydown="notMobile"
              @keyup="keyboardChangeSeats($event, key)"
              :disabled="isOperated(key)"
            />
          </div>
        </div>
      </div>
      <template v-if="page == totalNum">
        <div
          class="input-panel"
          v-for="(item, index) in complement"
          :key="index + 900"
        ></div>
      </template>
    </div>
  </div>
  <!-- end 输入面板 -->
</template>

<script>
export default {
  name: "InputPanel",
  data() {
    return {
      //转换后的数据
      inputVals: [],
      // 页码
      page: 1,
      // 当前行数
      refKey: 0,
      // 返回上一行
      returnPreviousRow: false,
      // 总页数
      totalNum: 0,
      // 补全
      complement: 0,
      isLoading: true,
    };
  },
  props: {
    // 数据列表
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 是否分页
    isPaging: {
      type: Boolean,
      default: false,
    },
    // 一页显示行数
    showLineNumber: {
      type: Number,
      default: 1,
    },
    // 是否开始
    obtainCursor: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // 监听是否开始
    obtainCursor: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal == true) {
          let that = this;
          if (this.isPaging) {
            this.$nextTick(() => {
              that.$refs["input-" + that.refKey][0].focus();
            });
          } else {
            this.$nextTick(() => {
              that.$refs["key"][0].focus();
            });
          }
        }
      },
    },
    // 监听换行
    refKey: {
      handler(newVal, oldVal) {
        let that = this;
        if (this.isPaging) {
          this.$nextTick(() => {
            let obj = that.$refs["input-" + newVal];
            if (obj.length != 0) {
              obj[0].focus();
            }
          });
        } else {
          this.$nextTick(() => {
            that.$refs["key"][0].focus();
          });
        }
        if (newVal < oldVal) {
          //后退
          let str = this.inputVals[newVal];
          if (str != "" && str != null) {
            this.inputVals[newVal] = str.substr(0, str.length - 1);
          }
          //this.returnPreviousRow = false;
        }
      },
    },
    // 监听数据
    value: {
      handler(newVal) {
        this.totalNum = Math.ceil(newVal.length / this.showLineNumber);
        this.complement = this.showLineNumber * this.totalNum - newVal.length;
      },
    },
    // 监听数据
    inputVals: {
      handler(newVal) {
        // 载入参数
        this.value.forEach((item, key) => {
          if (newVal[key] != undefined) {
            let arr = newVal[key].split("");
            this.value[key].forEach((item, keys) => {
              this.value[key][keys].inputVal = arr[keys];
            });
          }
          if (this.automaticPagingPro(this.value, this.page)) {
            this.page++;
          }
        });
        // 自动切换下一行 Current
        if (null != newVal[this.refKey]) {
          let currentArr = newVal[this.refKey].split("");
          if (this.value[this.refKey].length == currentArr.length) {
            this.refKey++;
            this.$emit("pageTurning", this.page);
            this.returnPreviousRow = true;
            return;
          }
          if (currentArr != 0) {
            this.returnPreviousRow = false;
          }
        }
      },
    },
  },
  created() {
    //this.totalNum = Math.ceil(this.value.length / this.showLineNumber);
    //this.complement = this.showLineNumber * this.totalNum - this.value.length;
    //console.log(this.value.length);
  },
  methods: {
    // 初始化
    init() {
      this.isLoading = false;
      let that = this;
      setTimeout(function () {
        that.reload();
        // 这里就是处理的事件
      }, 100);
    },
    // 重新加载
    reload() {
      this.inputVals = [];
      this.page = 1;
      // 当前行数
      this.refKey = 0;
      // 返回上一行
      this.returnPreviousRow = false;
      // 总页数
      this.totalNum = Math.ceil(this.value.length / this.showLineNumber);
      // 补全
      this.complement = this.showLineNumber * this.totalNum - this.value.length;
      this.$forceUpdate();
      this.isLoading = true;
      this.startFun();
    },
    // 启动
    startFun() {
      if (this.obtainCursor == true) {
        let that = this;
        if (this.isPaging) {
          if (that.$refs["input-" + that.refKey].length != 0) {
            this.$nextTick(() => {
              that.$refs["input-" + that.refKey][0].focus();
            });
          }
        } else {
          this.$nextTick(() => {
            that.$refs["key"][0].focus();
          });
        }
      }
    },
    // 是否可以操作
    isOperated(key) {
      if (this.obtainCursor && key == this.refKey) {
        return false;
      }
      return true;
    },
    // input ref 名字
    inputRefName(key) {
      //this.refKey = key;
      return "input-" + key;
    },
    // 验证页码
    verifyPage(key) {
      let startNum = 1 + (this.page - 1) * this.showLineNumber;
      let endNum =
        1 + (this.page - 1) * this.showLineNumber + (this.showLineNumber - 1);
      if (startNum <= key && endNum >= key) {
        return true;
      }
      return false;
    },
    // 禁止移动
    notMobile(event) {
      if (event.keyCode == 37 || event.keyCode == 39) {
        event.preventDefault();
        return false;
      }
    },
    // 按键字符
    keyboardChangeSeats(event) {
      if (event.code == "Backspace") {
        if (
          (this.inputVals[this.refKey] == null ||
            this.inputVals[this.refKey] == "") &&
          this.returnPreviousRow == false
        ) {
          this.returnPreviousRow = true;
          this.$emit("keyboardChangeSeats", event);
          return;
        }
        if (
          (this.inputVals[this.refKey] == null ||
            this.inputVals[this.refKey] == "") &&
          this.returnPreviousRow == true &&
          this.verifyCutLastrow()
        ) {
          this.refKey--;
          this.$emit("keyboardChangeSeats", event);
          return;
        }
      }
    },
    // 翻页
    automaticPagingPro(data, page) {
      let startNum = 1 + (page - 1) * this.showLineNumber;
      let endNum =
        1 + (page - 1) * this.showLineNumber + (this.showLineNumber - 1);
      let totalNum = Math.ceil(data.length / this.showLineNumber);
      if (page >= totalNum) {
        return false;
      }
      let total = 0;
      let inputLength = 0;
      data.forEach((item, key) => {
        if (startNum <= key + 1 && endNum >= key + 1) {
          item.forEach((items) => {
            total++;
            if (items.inputVal != null) {
              inputLength++;
            }
          });
        }
      });
      if (total <= inputLength) {
        return true;
      }
      return false;
    },
    // 验证是否可以切换到上一行
    verifyCutLastrow() {
      let startNum = 1 + (this.page - 1) * this.showLineNumber;
      if (this.refKey == startNum - 1) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped lang="scss">

.input-class{
  padding-bottom: 10px !important;
  box-sizing: border-box;
}
.input-panel {
  width: 898px;
  height: 73px;
  background: #fbfbfb;
  box-shadow: inset 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #dbdbdb;
  padding: 10px 10px;
  box-sizing: border-box;
  margin-bottom: 8px;
  span {
    padding: 0px;
  }
  .show-input-panel {
    letter-spacing: 2px;
    width: 100%;
    color: #000000;
    font-weight: 400;
    font-family: "CumberlandStd";
    font-size: 18px;
    //word-spacing: 12px;
    padding: 0 0;
  }
  .input-panel-input {
    width: 100%;
    margin-top: 5px;
    input {
      color: #9d9d9d;
      width: 100%;
      font-weight: 400;
      font-size: 18px;
      background: none;
      outline: none;
      border: none;
      padding: 0;
      letter-spacing: 2px;
      font-family: "CumberlandStd";
      //word-spacing: 12px;
    }
  }
  .mistake {
    color: red;
  }
}
</style>
